class giftCertificate {
	constructor() {
		this.init();
	}

	giftCertificate = (giftCertificateForm) => {
		fetch(prx, {
			method: `POST`,
			headers: {
				'Content-Type': `application/json`,
				'x-shopify-hmac-sha256': gcHash,
				'x-shopify-topic': `gift_cards/get`
			},
			body: `${customerEmail}||${cid}`
		}).then(res => res.json()).then(data => {
            const giftCards=data.data.giftCards.nodes;
			if (giftCards.length > 0) {
				let giftCardTable = ``;
				let totalGiftCardPrice = 0;
				let remainingBalance = 0;
				giftCards.forEach(item => {
					const dateFormat = new Date(item.createdAt);
					let year = dateFormat.getFullYear();
					let month = dateFormat.toLocaleString(`default`, {month: `long`});
					let day = dateFormat.getDate();
					if (day == 0) {
						const current = new Date(item.createdAt);
						current.setMonth(current.getMonth() - 1);
						const previousMonth = current.toLocaleString(`default`, {month: `long`});
						month = previousMonth;
						day = new Date(year, current.getMonth() + 1, 0).getDate();
					}
					const date = `${month}, ${day}, ${year}`;
					remainingBalance += +(item.balance.amount);
					totalGiftCardPrice += +(item.initialValue.amount);

					let expireDate = `Never`;
					if (item.expiresOn != null) {
						expireDate = new Date(item.expiresOn);
						const D = expireDate.getDate();
						const M = expireDate.toLocaleString(`default`, {month: `long`});
						const Y = expireDate.getFullYear();
						expireDate = `${M}, ${D} ${Y}`;
					}
					giftCardTable += `<tr>
						<td class="border-0 py-1">**** **** **** ${item.lastCharacters}</td>
						<td class="border-0 py-1">${date}</td>
						<td class="border-0 py-1">${expireDate}</td>
						<td class="border-0 py-1">${Shopify.formatMoney((item.initialValue.amount * 100), window.globalVariables.money_format).replaceAll(` USD`, ``).replaceAll(` CAD`, ` USD`)}</td>
						<td class="border-0 py-1">${Shopify.formatMoney((item.balance.amount * 100), window.globalVariables.money_format).replaceAll(` USD`, ``).replaceAll(` CAD`, ` USD`)}</td>
					</tr>`;
				});
				let html = `<table class="mt-5 table">
						<thead>
						<tr>
							<td class="border-0">Gift Card Code</td>
							<td class="border-0">Date Issued</td>
							<td class="border-0">Expires</td>
							<td class="border-0">Initial Balance</td>
							<td class="border-0">Current Balance</td>
						</tr>
						</thead>
						<tbody>
						${giftCardTable}
						</tbody>
					</table>
					<div class="text-end">Total Available Credit: ${Shopify.formatMoney((remainingBalance * 100), window.globalVariables.money_format).replaceAll(` USD`, ``).replaceAll(` CAD`, ` USD`)}</div>`;
				document.querySelector(`#listGiftCard`).innerHTML = html;
			} else {
				let html = `<div class="mt-5">Your account has no available credit certificates.</div>`;
				document.querySelector(`#listGiftCard`).innerHTML = html;
			}
		});
	};
	

	init = () => {
		const giftCertificateForm = document.querySelector(`#listGiftCard`);
		if (giftCertificateForm != null) {
			this.giftCertificate();
		}
	};
}

new giftCertificate;